import React from 'react';
import { IonSpinner } from '@ionic/react';
import { useAuthStore } from '../../store/useAuthStore';
import { useProfileStore } from '../../store/useProfileStore';

interface AuthGuardProps {
  children: React.ReactNode;
}

// With optimistic paint, `useAuthStore.isLoading` is always false, so the
// old "auth-restore spinner" branch is dropped. The remaining `!activeProfile`
// spinner only fires for ProtectedRoute children (Profile, Publish, Orders,
// etc.) — the public HomePage paints immediately. Once whoami's profile
// fetch returns (~600ms), `activeProfile` populates and children render.
export const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const { activeProfile } = useProfileStore();

  if (isAuthenticated && !activeProfile) {
    return (
      <div className="flex h-screen items-center justify-center bg-background flex-col gap-4">
        <IonSpinner name="crescent" />
        <p className="text-muted-foreground text-sm">Loading profile...</p>
      </div>
    );
  }

  return <>{children}</>;
};
